module.exports = __webpack_public_path__ + "static/ribslogo-174630f6096a9130daa4794b8c742803.png";